import {
  Accordion,
  Button,
  Text,
  Title,
  Table,
  Select,
  Group,
  Checkbox,
} from "@mantine/core";
import React, { useState, useEffect } from "react";
import moment from "moment";
import { useServerApi } from "../hooks/userServerApi";
import { DatePicker } from "@mantine/dates";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { openFileUrl } from "../utils/openReport";

const ReportGIPendingSettlement = ({}) => {
  const [loading, setLoading] = useState(false);
  const [includePendingPayment, setIncludePendingPayment] = useState(true);

  const [api] = useServerApi();
  const { t } = useTranslation();

  const downloadReport = async () => {
    try {
      setLoading(true);

      // console.log(fromDate, toDate);

      const result = await api.DebitNote.getPendingSettlementReport({
        includePendingPayment: includePendingPayment,
      });
      setLoading(false);
      // console.log(result);
      if (result && result.data && result.data.url) {
        await openFileUrl(result.data.url);
      }
    } catch (error) {
      setLoading(false);
      // console.log(error);
    }
  };

  return (
    <div>
      <Text size="xs">
        {t(
          "Please click the below button to download the pending settlement report."
        )}
      </Text>

      <Button
        size="xs"
        mt="xl"
        onClick={() => downloadReport()}
        loading={loading}
      >
        {t("Download")}
      </Button>
      <></>
    </div>
  );
};

export default ReportGIPendingSettlement;
